var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    _vm._b(
      {
        ref: "dialog",
        attrs: {
          scrollable: "",
          persistent: _vm.persistent,
          eager: ""
        },
        on: {
          keydown: function keydown($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            ) {
              return null
            }
            return _vm.$emit("close")
          }
        },
        model: {
          value: _vm.modal,
          callback: function callback($$v) {
            _vm.modal = $$v
          },
          expression: "modal"
        }
      },
      "v-dialog",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "v-card",
        {
          staticClass: "app-card card-borderless"
        },
        [
          _vm.isShowHeader
            ? _c(
                "v-toolbar",
                {
                  attrs: {
                    dark: _vm.headerDark,
                    color: _vm.headerColor
                  }
                },
                [
                  _c(
                    "div",
                    {
                      class: _vm.classHeader,
                      style: _vm.styleForHeaderContainer
                    },
                    [
                      _vm.isShowHeaderClose
                        ? _c(
                            "div",
                            [
                              _vm._t("header-close", [
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      dark: "",
                                      elevation: "0",
                                      "aria-label": "Close"
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.$emit("close")
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("mdi-close")])],
                                  1
                                )
                              ])
                            ],
                            2
                          )
                        : _vm._e(),
                      _c("div", [_vm._t("header")], 2)
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm.isShowTitle
            ? _c("v-card-title", [
                _c(
                  "div",
                  {
                    class: _vm.classTitle,
                    style: _vm.styleForTitleContainer
                  },
                  [
                    _vm._t("title"),
                    _vm.isShowTitleClose
                      ? _c(
                          "div",
                          [
                            _vm._t("title-close", [
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    dark: "",
                                    elevation: "0",
                                    "aria-label": "Close"
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.$emit("close")
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-close")])],
                                1
                              )
                            ])
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm.isBodySlotActive
            ? _c(
                "v-card-text",
                {
                  staticClass: "pt-2 pb-3"
                },
                [_vm._t("body")],
                2
              )
            : _vm._e(),
          _vm.isShowFooter
            ? _c(
                "v-card-actions",
                {
                  class: _vm.classFooter,
                  style: _vm.styleForFooterContainer
                },
                [
                  _vm._t("footer", [
                    _c(
                      "gg-btn",
                      _vm._b(
                        {
                          attrs: {
                            text: ""
                          },
                          on: {
                            click: function click($event) {
                              return _vm.$emit("close")
                            }
                          }
                        },
                        "gg-btn",
                        _vm.footerCloseAttrs,
                        false
                      ),
                      [_vm._v(" " + _vm._s(_vm.footerCloseText) + " ")]
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }